import { Extension, type Editor } from '@tiptap/core';

export const OPEN_LINK_POPOVER_EVENT = 'bh-open-link-popover';
export const TOGGLE_MARKDOWN_SOURCE_EVENT = 'bh-toggle-markdown-source';

type CustomEditorEvent = typeof OPEN_LINK_POPOVER_EVENT | typeof TOGGLE_MARKDOWN_SOURCE_EVENT;

function asCustomEventEmitter(editor: Editor) {
  return editor as unknown as {
    on: (event: CustomEditorEvent, fn: () => void) => void;
    off: (event: CustomEditorEvent, fn: () => void) => void;
    emit: (event: CustomEditorEvent) => void;
  };
}

export function emitEditorEvent(editor: Editor, event: CustomEditorEvent) {
  asCustomEventEmitter(editor).emit(event);
}

export function onEditorEvent(editor: Editor, event: CustomEditorEvent, fn: () => void) {
  asCustomEventEmitter(editor).on(event, fn);
}

export function offEditorEvent(editor: Editor, event: CustomEditorEvent, fn: () => void) {
  asCustomEventEmitter(editor).off(event, fn);
}

export function isMarkdownToggleShortcut(event: {
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
  shiftKey: boolean;
  code: string;
}): boolean {
  const mod = event.metaKey || event.ctrlKey;
  return mod && event.altKey && event.shiftKey && event.code === 'KeyM';
}

export const GlobalEditorShortcuts = Extension.create({
  name: 'globalEditorShortcuts',
  addKeyboardShortcuts() {
    return {
      'Mod-k': () => {
        emitEditorEvent(this.editor, OPEN_LINK_POPOVER_EVENT);
        return true;
      },
      'Mod-Alt-Shift-m': () => {
        emitEditorEvent(this.editor, TOGGLE_MARKDOWN_SOURCE_EVENT);
        return true;
      },
      'Mod-Alt-0': () => this.editor.commands.setParagraph()
    };
  }
});
